<section id="canvasVideoComponent" class="viewerAsset viewerAssetVideoCanvas">
  <div id="canvasVideoWrapper"
       class="d-flex flex-column mx-auto justify-content-center align-items-center"
       [style.--video-width]="videoWidth"
       [style.--video-height]="videoHeight"
       [style.--canvas-width]="canvasWidth"
       [style.--canvas-height]="canvasHeight">
    <div class="videoViewerContainer w-100">
      <zbp-viewer-video
        [asset]="asset"
        (loaded)="completedVideoLoading()"
        (withError)="withError.emit($event)"
        (videoDimensions)="loadVideoDimensions($event)"
      />
    </div>
    <div class="canvasViewerContainer w-100">
      <zbp-viewer-canvas
        [asset]="asset"
        [series]="series"
        [grade]="grade"
        [selectedTool]="selectedTool"
        (loaded)="completeImageLoading()"
        (withError)="withError.emit($event)"
        [drawingColor]="drawingColor"
        [brushSize]="brushSize"
        [clearClicked]="clearClicked"
        (imageDimensions)="loadCanvasImageDimensions($event)">
      </zbp-viewer-canvas>
    </div>
  </div>
</section>
